module.exports = __webpack_public_path__ + "img/e1.5be34093.svg";